import React from 'react';
import Swal from "sweetalert2";

import { useTranslation } from "react-i18next";

import * as commonFunc from 'scripts/common';

import {
    Button, Col
} from "reactstrap";


export default function CollectionFrag(props) {
    const { data, formManager, modelFctManager, bindPropResult, parentProps, isConfiguration, childShouldRerender, parentDisabled, contextMenuManager } = props;

    const { t } = useTranslation();
    const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };
    const { register, getValues, setValue, resetField } = formManager;//, setValue, errors

    const [shouldRender, setShouldRender] = React.useState(false);

    React.useEffect(() => {
        if (data.onActionEvents && data.onActionEvents["onLoad"]) {
            data.onActionEvents["onLoad"].forEach((args, index) => {
                modelFctManager.onActionRequired(data.name, args, data).then(actionResponse => {
                    //console.debug("RESPONSE");
                    //console.debug(actionResponse);
                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                        Swal.fire({
                            icon: "error",
                            title: t("gal_fail"),
                            html: actionResponse.errorMessage
                        });
                    }
                });
            });
        }

        //TEMP : PB réactualisation bg button
        var backgroundRequired = document.querySelectorAll("[data-backimage]");
        backgroundRequired.forEach((node) => {
            node.style.setProperty("--bg-image", node.getAttributeNode("data-backimage").value);
            node.style.setProperty("--bg-opacity", node.getAttributeNode("data-imageopacity")?.value);
        });

        if ((!data.children || data.children.length === 0) && modelFctManager?.finalizeProcess) modelFctManager.finalizeProcess(data, parentProps);
    }, []);
    React.useEffect(() => {
        data.childRendered = 0;
        if (childShouldRerender && modelFctManager?.commonRenderProc) modelFctManager.commonRenderProc(data);
    }, [props]);
    if (!childShouldRerender && modelFctManager?.commonRenderProc) modelFctManager.commonRenderProc(data);



    var onClick = (e, collectionKey, collection) => {
        if(e) e.preventDefault();
        if (!disabled) {

            if (!collection) {
                var values = getValues(bindPropResult);
                var collections = JSON.parse(values);
                if (Array.isArray(collections)) {
                    collection = {};

                    var extras = getValues("extras");
                    Object.keys(extras).forEach(keyObj => {
                        var altExtraKey = collectionKey.replace("extras.", "");
                        if (keyObj === altExtraKey) {
                            collection = extras[keyObj];
                        }
                    });
                }
            }

            //Si nouvelle collection, récupération des valeurs externes par défaut
            if (collection && Object.keys(collection).length > 0 && !collection.isCollection) {
                Object.keys(collection).forEach((key) => {
                    if (key && collection[key]?.startsWith && collection[key].startsWith("args:")) {
                        var cptArgs = getValues(commonFunc.camelize(collection[key].replace("args:", ""), true));
                        collection[key] = cptArgs;
                    }
                });
            }
            else if ((!collection || Object.keys(collection).length <= 0) && data.argumentsObj?.collectionArgs?.defaultArgs) {
                collection = data.argumentsObj?.collectionArgs?.defaultArgs;
                Object.keys(collection).forEach((key) => {
                    if (key && collection[key]?.startsWith && collection[key].startsWith("args:")) {
                        var cptArgs = getValues(commonFunc.camelize(collection[key].replace("args:", ""), true));
                        collection[key] = cptArgs;
                    }
                });
            }


            if (data.onActionEvents && data.onActionEvents["onClick"]) {
                data.onActionEvents["onClick"].forEach((args, index) => {
                    //args.value / args.target
                    modelFctManager.onActionRequired(data.name, args, data, { type: data.subType, key: collectionKey, data: collection, value: collection }, e).then(actionResponse => {
                        //console.debug("RESPONSE");
                        //console.debug(actionResponse);
                        if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                            Swal.fire({
                                icon: "error",
                                title: t("gal_fail"),
                                html: actionResponse.errorMessage
                            });
                        }
                    });
                });
            }
        }
    };

    data.functionManager = {};
    data.functionManager.getParentProps = () => { return parentProps; };
    data.functionManager.rerender = () => { setShouldRender(!shouldRender) };
    data.functionManager.performClick = (e, key, dataCollection) => {
        var values = getValues(bindPropResult);
        var collections = JSON.parse(values);
        if (Array.isArray(collections)) {
            onClick(null, key, null);
        }
        else {
            if (collections[key]) {
                if (!dataCollection) onClick(null, key, collections[key]);
                else onClick(null, key, dataCollection);
            }
        }
    };
    data.functionManager.triggerChange = (collectionKey, collection) => {
        return new Promise((resolve, reject) => {

            if (data.onActionEvents && data.onActionEvents["onChange"]) {
                data.onActionEvents["onChange"].forEach((args, index) => {
                    //var val = bindPropResult ? getValues(bindPropResult) : "";
                    modelFctManager.onActionRequired(data.name, args, data, { type: data.subType, key: collectionKey, data: collection, value: collection }).then(actionResponse => {
                        //console.debug("RESPONSE");
                        //console.debug(actionResponse);
                        if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                            Swal.fire({
                                icon: "error",
                                title: "Echec",
                                html: actionResponse.errorMessage
                            });
                        }
                    });
                });
            }

            resolve({ isSuccess: true, result: null });
        });
    };
    data.functionManager.setValue = (newValue) => {
        return new Promise((resolve, reject) => {
            var { key, data:dataCollection } = newValue?.value;
            var values = !commonFunc.isBlank(bindPropResult) ? getValues(bindPropResult) : "";
            var collections = {};
            if (!commonFunc.isBlank(values)) {
                collections = JSON.parse(values.toString());
            }
            if (collections) {
                delete dataCollection.extras;
                dataCollection.isCollection = true;
                if (Array.isArray(collections)) {
                    setValue(key, dataCollection);
                }
                else {
                    collections[key] = dataCollection;
                }
                setValue(bindPropResult, JSON.stringify(collections));
                setShouldRender(!shouldRender);
            }
            data.functionManager.triggerChange(key, dataCollection);

            resolve({ isSuccess: true, result: null });
        });
    };
    data.functionManager.removeItem = (e, key) => {
        return new Promise((resolve, reject) => {
            var values = !commonFunc.isBlank(bindPropResult) ? getValues(bindPropResult) : "";
            var collections = {};
            if (!commonFunc.isBlank(values)) {
                collections = JSON.parse(values.toString());
            }
            if (collections) {
                if (Array.isArray(collections)) {
                    collections = collections.filter(lKey => lKey !== key);
                    setValue(key, null);
                }
                else {
                    delete collections[key];
                }
                setValue(bindPropResult, JSON.stringify(collections));
                setShouldRender(!shouldRender);
            }
            data.functionManager.triggerChange(null, null);

            resolve({ isSuccess: true, result: null });
        });
    };
    data.functionManager.reset = () => {
        return new Promise((resolve, reject) => {

            var values = !commonFunc.isBlank(bindPropResult) ? getValues(bindPropResult) : "";
            var collections = {};
            if (!commonFunc.isBlank(values)) {
                collections = JSON.parse(values.toString());
            }
            if (collections && Array.isArray(collections)) {
                /*var extras = getValues("extras");
                Object.keys(extras).forEach(keyObj => {
                    var split = keyObj.split(".");
                    if (collections.indexOf("extras." + keyObj.replace("." + split[split.length - 1], "")) >= 0) delete extras[keyObj];
                });
                setValue("extras", extras);*/
                collections.forEach(subKey => {
                    setValue(subKey, null);
                    //resetField(subKey);
                });
            }
            setValue(bindPropResult, data.defaultValue);
            setShouldRender(!shouldRender);

            data.functionManager.triggerChange(null, null);

            resolve({ isSuccess: true, result: null });
        });
    };

    var defaultValue = data.defaultValue !== undefined ? data.defaultValue : "{}";
    register(bindPropResult, {
        value: defaultValue
    });

    var disabled = ((data.disabled ? true : false) || (!data.ignoreParentDisabled ? parentDisabled : false));

    var btnClass = "m-1";
    var btnSupClass = "";
    var btnStyle = { overflow: "hidden" };
    var containerStyle = {};
    var frameClass = "";
    var frameStyle = {};
    if (data.hidden) {
        if (isConfiguration) {
            frameClass += " config-hidden";
        }
        else {
            frameClass += " d-none";
        }
    }
    if (data.checkRights) {
        var hasRights = modelFctManager.checkRights(data.checkRights.entity, data.checkRights.rights);
        switch (data.checkRights.action) {
            case "disabled":
                if (!hasRights) disabled = true;
                break;
            case "invisible":
                if (!hasRights) frameClass += " invisible";
                break;
            default:
                if (!hasRights) frameClass += " d-none";
                break;
        }
    }
    if (commonFunc.isBlank(data.title) && (data.children == null || data.children.length === 0 || (data.children.length === 1 && data.children[0].objType !== "itemsContainer"))) btnSupClass += " btn-icon ";

    var design = data.customDesign?.design;
    design = modelFctManager.prepareMergedDesign(data, design, "default_collection");
    data.mergedDesign = design;
    if (design) {
        if (design.boxSize) {
            var supBoxSize = modelFctManager.manageBoxSize("item-" + parentProps?.parentData?.gridID + "-" + data?.key, design.boxSize, data);
            frameClass += supBoxSize;
            btnClass += supBoxSize;
        }

        if (design.height) btnStyle.height = design.height;
        if (design.width) btnStyle.width = design.width;

        var marginElevation = 0;
        if (design.elevation) {
            btnStyle.boxShadow = design.elevation + " " + design.elevation + " 5px rgba(0,0,0,.15)";
            marginElevation = parseInt(design.elevation.replace("px", ""));
        }

        //btnStyle.margin = design.margin;
        var margin = design.margin ? parseInt(design.margin.replace("px", "")) : -1;
        var marginTop;
        if (design.marginTop) {
            if (design.marginTop.indexOf("px") >= 0) {
                marginTop = parseInt(design.marginTop.replace("px", ""));
            }
            else {
                btnSupClass += design.marginTop;
            }
        }
        else {
            marginTop = margin;
        }
        var marginLeft = design.marginStart ? parseInt(design.marginStart.replace("px", "")) : margin;
        var marginBottom = design.marginBottom ? parseInt(design.marginBottom.replace("px", "")) : margin;
        var marginRight = design.marginEnd ? parseInt(design.marginEnd.replace("px", "")) : margin;

        if (marginLeft !== -1 || marginTop !== -1 || marginRight !== -1 || marginBottom !== -1) {
            if (marginTop !== -1) btnStyle.marginTop = (marginTop + marginElevation) + "px";
            if (marginRight !== -1) btnStyle.marginRight = (marginRight + marginElevation) + "px";
            if (marginBottom !== -1) btnStyle.marginBottom = (marginBottom + marginElevation) + "px";
            if (marginLeft !== -1) btnStyle.marginLeft = (marginLeft + marginElevation) + "px";
        }
        else {
            btnStyle.margin = marginElevation + "px";
        }
        if (design.margin) {
            btnClass = btnClass.replace("m-1", "");
        }

        if (design.fontColor) btnStyle.color = modelFctManager.getRgbaFromHex(design.fontColor);
        Object.assign(btnStyle, modelFctManager.setCustomBackground(design, data));
    }
    if (data.customDesign?.extrasDesign?.containerDesign) {
        Object.assign(containerStyle, modelFctManager.setCustomBackground(data.customDesign.extrasDesign.containerDesign, data));
    }

    data.childCount = data.children ? data.children.length : 0;
    var childs = data.children?.map((child) => { return modelFctManager.componentTyped(child, { ...parentProps, parentData: data, childs: data.children, parentDisabled: (parentDisabled || data.disabled ? true : false), stopPartition: (parentProps.stopPartition || data.groupSubName?.startsWith("containerGroup")) }); }) || "";


    var baseForm;

    var values = !commonFunc.isBlank(bindPropResult) ? getValues(bindPropResult) : "";
    var collections = {};
    if (!commonFunc.isBlank(values)) {
        collections = JSON.parse(values.toString());
    }

    //console.debug(collections);
    var collectionsLength;
    if (Array.isArray(collections)) {
        collectionsLength = collections.length;
        baseForm = <>
            {collections.map((collectionKey, index) => {
                if (index >= parseInt(data.attributes?.max)) return null;

                return <Button key={bindPropResult + "collection-" + collectionKey} color="none" className={`btn-sm ${btnClass} ${btnSupClass} ${data.classSup} ${data.customDesign?.extrasDesign?.containerDesign ? "p-0" : ""}`} style={btnStyle} data-backimage={btnStyle.hasImage || null} data-imageopacity={btnStyle.alpha || null}
                    disabled={disabled} onClick={(e) => {
                        onClick(e, collectionKey, null);
                    }}
                    onContextMenu={e => {
                        if (!data.argumentsObj?.collectionArgs?.preventMenu && contextMenuManager.showContextMenu) {
                            contextMenuManager.showContextMenu({
                                id: "contextMenu-" + contextMenuManager.className,
                                event: e,
                                props: { key: collectionKey, value: null, data: data },
                            });
                        }
                    }} {...configAttr}>
                    <div style={containerStyle} data-backimage={containerStyle.hasImage || null} data-imageopacity={containerStyle.alpha || null}>
                        {(!design?.position || design?.position === "start" || design?.position === "left") ? childs : ""}
                        {altT(data.title)}
                        {(design?.position === "right" || design?.position === "end") ? childs : ""}
                    </div>
                </Button>;
            }).filter(r => r !== null)}
            {!data.argumentsObj?.collectionArgs?.preventAdd && collectionsLength < parseInt(data.attributes?.max) && <Button className="btn-sm btn-icon btn-round" color="success" onClick={(e) => {
                var tempID = parseInt(Math.floor(Date.now() + Math.random() * 1000000000000001).toString().substring(6));
                onClick(e, bindPropResult + "_btn" + tempID, {});
            }}><i className="fa fa-plus"></i></Button>}
        </>;
    }
    else {
        collectionsLength = Object.keys(collections).length;
        baseForm = <>
            {Object.keys(collections).map((collectionKey, index) => {
                if (index >= parseInt(data.attributes?.max)) return null;
                var collection = collections[collectionKey];

                return <Button key={bindPropResult + "collection-" + collectionKey} color="none" className={`btn-sm ${btnClass} ${btnSupClass} ${data.classSup} ${data.customDesign?.extrasDesign?.containerDesign ? "p-0" : ""}`} style={btnStyle} data-backimage={btnStyle.hasImage || null} data-imageopacity={btnStyle.alpha || null}
                    disabled={disabled} onClick={(e) => {
                        onClick(e, collectionKey, collection);
                    }}
                    onContextMenu={e => {
                        if (!data.argumentsObj?.collectionArgs?.preventMenu && contextMenuManager.showContextMenu) {
                            contextMenuManager.showContextMenu({
                                id: "contextMenu-" + contextMenuManager.className,
                                event: e,
                                props: { key: collectionKey, value: collection, data: data },
                            });
                        }
                    }} {...configAttr}>
                    <div style={containerStyle} data-backimage={containerStyle.hasImage || null} data-imageopacity={containerStyle.alpha || null}>
                        {(!design?.position || design?.position === "start" || design?.position === "left") ? childs : ""}
                        {altT(data.title)}
                        {(design?.position === "right" || design?.position === "end") ? childs : ""}
                    </div>
                </Button>;
            }).filter(r => r !== null)}
            {!data.argumentsObj?.collectionArgs?.preventAdd && collectionsLength < parseInt(data.attributes?.max) && <Button className="btn-sm btn-icon btn-round" color="success" onClick={(e) => {
                var tempID = parseInt(Math.floor(Date.now() + Math.random() * 1000000000000001).toString().substring(6));
                onClick(e, "btn" + tempID, {});
            }}><i className="fa fa-plus"></i></Button>}
        </>;
    }

    var configAttr = (isConfiguration ? {} : {});

    return <Col data-name="CollectionFrag" data-element={data.objType} data-bind={bindPropResult} xs="auto" className={` ${frameClass} ${parentProps.parentData.customDesign && parentProps.parentData.customDesign.design && parentProps.parentData.customDesign.design.spacing ? "" : "p-0"}`} style={frameStyle}>
        {baseForm}
    </Col>;//align-self-center
}